import React from 'react';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
import slugify from '../../utils/slugify';
import Select from './Select';
import styles from './BrandEquipmentFilter.module.css';
import { sortTypes, sortSubtypes, sortMarketTypes } from '../../utils/sortEquipmentTypes';

interface Props {
  loading: boolean;
  changePage: (page: string) => void;
  data: any[];
  type?: string;
  subtype?: string;
  marketType?: string;
  search?: string;
  changeSearch: (search: string) => void;
}

function Filter({ type = '', subtype = '', marketType = '', search = '', ...props }: Props) {
  if (props.loading) {
    return null;
  }

  function handleTypeChange(value) {
    props.changePage(value ? slugify(value) : '');
  }

  function handleSubTypeChange(value) {
    const prefix = type + '/';
    props.changePage(value ? prefix + slugify(value) : prefix);
  }

  function handleMarketTypeChange(value) {
    const prefix = type + '/' + subtype + '/';
    props.changePage(value ? prefix + slugify(value) : prefix);
  }

  // Filter list of types
  const types = props.data.sort(sortTypes).map(type => type.equipment_type_name);

  let subtypes = null;
  let marketTypes = null;
  if (type != '' && props.data.length > 0) {
    // Filter list of subtypes
    const currentType = props.data.find(t => slugify(t.equipment_type_name) === type);
    if (currentType && currentType.subtypes) {
      subtypes = currentType.subtypes.map(subtype => subtype.equipment_sub_type_name.replace('/', '-'));
      // Filter list of market types
      if (subtype != '' && props.data.length > 0) {
        const currentSubtype = currentType.subtypes.find(s => slugify(s.equipment_sub_type_name) === subtype);
        if (currentSubtype && currentSubtype.market_types) {
          marketTypes = currentSubtype.market_types.map(marketType => marketType.name);
        }
      }
    }
  }

  return (
    <Paper className={styles.root}>
      <Select
        label="Type"
        show={true}
        handleSelect={handleTypeChange}
        selected={type}
        options={types}
      />
      <Select
        label="Subtype"
        show={type != '' && subtypes !== null}
        handleSelect={handleSubTypeChange}
        selected={subtype}
        options={subtypes?.sort(sortSubtypes)}
      />
      <Select
        label="Market Type"
        show={type != '' && subtype != '' && marketTypes !== null && marketTypes.length > 1}
        handleSelect={handleMarketTypeChange}
        selected={marketType}
        options={marketTypes?.sort(sortMarketTypes)}
      />
      <TextField
        style={{ marginLeft: 'auto' }}
        label="Search Model Number"
        value={search}
        onChange={e => props.changeSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => props.changeSearch('')} size="large">
                <Close />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Paper>
  );
}

export default Filter;
